
import { defineComponent, inject, ref } from 'vue'
import sPerson from "@/components/wizard/steps/sPerson.vue";

export default defineComponent({
    name: "person-modal-register",
    components: {sPerson},
    emits: ["onResponse"],
    setup(props, { emit }) {
        const dialog_register = inject<any>('dialog_register')

        const onResponse = (data) => {
            if(data.status == 'success'){
                dialog_register.value = false
                emit("onResponse", data)
            }

        }

        return {
            dialog_register,
            onResponse
        }
        
    },
})
